import { render } from "./events-management.vue?vue&type=template&id=5dcb5a2e"
import script from "./events-management.vue?vue&type=script&lang=js"
export * from "./events-management.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__